module.exports = __webpack_public_path__ + "static/img/wall-8m-x-4m-steel_256.634f087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-8m-x-4m-steel_256.png
// module id = t8Pi
// module chunks = 0